export default __webpack_public_path__ + "static/metaImage-2e59bbff394e275f24ae1448c6c0970f.jpg";